module.exports = __webpack_public_path__ + "img/katarina_living_room_11.e4c47a89.jpg";